import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

export const makeClient = () =>
  new ApolloClient({
    link: new HttpLink({ uri: process.env.GRAPHQL_URL }),
    cache: new InMemoryCache(),
  });
